import { render } from "./MultipleXChooseYSelectionDialog.vue?vue&type=template&id=377530a8&scoped=true"
import script from "./MultipleXChooseYSelectionDialog.vue?vue&type=script&lang=js"
export * from "./MultipleXChooseYSelectionDialog.vue?vue&type=script&lang=js"

import "./MultipleXChooseYSelectionDialog.vue?vue&type=style&index=0&id=377530a8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-377530a8"]])

export default __exports__